export default __webpack_public_path__ + "static/media/Doxxed Team 8.48bcce0d.jpg";